/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Artcraft_TitleInputs */

const en_home_artcraft_title = /** @type {(inputs: Home_Artcraft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ArtCraft CADCraft: part of an open-source suite`)
};

/**
* | output |
* | --- |
* | "ArtCraft CADCraft: part of an open-source suite" |
*
* @param {Home_Artcraft_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_artcraft_title = /** @type {((inputs?: Home_Artcraft_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Artcraft_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_artcraft_title(inputs)
});
export { home_artcraft_title as "home.artcraft.title" }